<div class="sidebar" [class.collapsed]="isCollapsed" 
     (mouseenter)="onMouseEnter()" 
     (mouseleave)="onMouseLeave()">
  <!-- Toggle Button -->
  <button class="sidebar-toggle" (click)="toggleSidebar()" pButton type="button" 
          [icon]="isCollapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
          class="p-button-text p-button-rounded"></button>

  <!-- Sidebar Content -->
  <div class="sidebar-content" *ngIf="isAuthenticated">

    <!-- Module switcher (CAC / CAS) -->
    <div class="module-switcher" *ngIf="!isCollapsed">
      <button
        pButton
        type="button"
        label="CAC"
        class="p-button-sm"
        [outlined]="selectedModule !== 'CAC'"
        (click)="selectModule('CAC')"
      ></button>
      <button
        pButton
        type="button"
        label="CAS"
        class="p-button-sm"
        [outlined]="selectedModule !== 'CAS'"
        (click)="selectModule('CAS')"
      ></button>
    </div>
    
    <!-- Navigation Menu -->
    <nav class="sidebar-nav">
      <h3 class="sidebar-section-title" *ngIf="!isCollapsed">Navigation</h3>
      
      <!-- CAC Module Items -->
      <a *ngIf="selectedModule === 'CAC' && !isOnModuleSelector" routerLink="/cac/dashboard" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-chart-line"></i>
        <span *ngIf="!isCollapsed">Tableau de Bord</span>
      </a>
      
      <a *ngIf="selectedModule === 'CAC' && !isOnModuleSelector" routerLink="/cac/comparaison" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-chart-bar"></i>
        <span *ngIf="!isCollapsed">Comparateur CAC</span>
      </a>
      
      <a *ngIf="selectedModule === 'CAC' && !isOnModuleSelector" routerLink="/cac/project-history" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-history"></i>
        <span *ngIf="!isCollapsed">Historique CAC</span>
      </a>

      <a *ngIf="selectedModule === 'CAC'" routerLink="/cac/contacts" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-users"></i>
        <span *ngIf="!isCollapsed">Contacts</span>
      </a>

      <a *ngIf="selectedModule === 'CAC'" routerLink="/cac/transactions" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-briefcase"></i>
        <span *ngIf="!isCollapsed">Transactions</span>
      </a>

      <a *ngIf="selectedModule === 'CAC'" routerLink="/cac/agenda-projects" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-calendar"></i>
        <span *ngIf="!isCollapsed">Agenda Projects</span>
      </a>

      <a *ngIf="selectedModule === 'CAC'" routerLink="/cac/email-issues" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-envelope"></i>
        <span *ngIf="!isCollapsed">Emails Gmail</span>
      </a>
      
      <!-- CAS Module Items -->
      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/compare" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-search"></i>
        <span *ngIf="!isCollapsed">Comparateur CAS</span>
      </a>

      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/dashboard" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-chart-line"></i>
        <span *ngIf="!isCollapsed">Dashboard CAS</span>
      </a>

      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/agenda" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-calendar"></i>
        <span *ngIf="!isCollapsed">Agenda CAS</span>
      </a>

      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/contacts" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-users"></i>
        <span *ngIf="!isCollapsed">Contacts CAS</span>
      </a>

      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/transactions" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-briefcase"></i>
        <span *ngIf="!isCollapsed">Transactions CAS</span>
      </a>
      
      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/historique" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-clock"></i>
        <span *ngIf="!isCollapsed">Historique CAS</span>
      </a>

      <a *ngIf="selectedModule === 'CAS' && (userEmail === 'contact@brokin.fr' || userEmail === 'contact@brokins.fr')" routerLink="/cas/compare-entreprise" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-building"></i>
        <span *ngIf="!isCollapsed">Comparateur Entreprise</span>
      </a>

      <a *ngIf="selectedModule === 'CAS' && isAdmin" routerLink="/cas/admin/catalogue-produits" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-list"></i>
        <span *ngIf="!isCollapsed">Catalogue produits</span>
      </a>

      <a *ngIf="selectedModule === 'CAS' && isAdmin" routerLink="/cas/admin/commissions" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-percentage"></i>
        <span *ngIf="!isCollapsed">Commissions</span>
      </a>

      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/credentials-sante" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-key"></i>
        <span *ngIf="!isCollapsed">Credentials santé</span>
      </a>

      <a *ngIf="selectedModule === 'CAS'" routerLink="/cas/email-issues" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-envelope"></i>
        <span *ngIf="!isCollapsed">Emails Gmail</span>
      </a>
    </nav>

    <!-- Admin Section -->
    <nav class="sidebar-nav" *ngIf="isAdmin">
      <div class="sidebar-divider"></div>
      <h3 class="sidebar-section-title" *ngIf="!isCollapsed">Administration</h3>
      
      <a routerLink="/cac/user" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-users"></i>
        <span *ngIf="!isCollapsed">Utilisateurs</span>
      </a>
      
      <a routerLink="/cac/compte" routerLinkActive="active" class="sidebar-item">
        <i class="pi pi-id-card"></i>
        <span *ngIf="!isCollapsed">Compte</span>
      </a>
    </nav>

    <!-- Bottom Section -->
    <div class="sidebar-bottom">
      <div class="sidebar-divider"></div>
      
      <a routerLink="/home" class="sidebar-item">
        <i class="pi pi-home"></i>
        <span *ngIf="!isCollapsed">Accueil</span>
      </a>
      
      <a (click)="logout()" class="sidebar-item logout-item">
        <i class="pi pi-sign-out"></i>
        <span *ngIf="!isCollapsed">Déconnexion</span>
      </a>
    </div>
  </div>
</div>
